import React from 'react'
import { Table, Button } from 'semantic-ui-react'
import moment from 'moment'

import TranscriptionStatus from './TranscriptionStatus'

import './TranscriptionItem.css'

export default class TranscriptionItem extends React.Component {
  render () {
    const { transcription } = this.props

    const status = transcription.transcriptionJob
      ? transcription.transcriptionJob.TranscriptionJobStatus
      : 'pending'

    const isComplete = status === 'COMPLETED'

    return (
      <Table.Row className='TranscriptionItem'>
        <Table.Cell
          style={{ cursor: 'pointer', color: '#2185d0' }}
          onClick={this.handleSelect}
        >
          {transcription.title}
        </Table.Cell>
        <Table.Cell collapsing>
          {this.formatCreatedAt(transcription.createdAt)}
        </Table.Cell>
        <Table.Cell collapsing>
          <TranscriptionStatus transcription={transcription} />
        </Table.Cell>

        <Table.Cell collapsing>
          <Button.Group basic size='small'>
            {/* <Button
              icon='download'
              onClick={this.handleDownload}
              loading={this.props.isDownloading}
              disabled={!isComplete}
            /> */}
            <Button
              icon='delete'
              onClick={this.handleDelete}
              loading={this.props.isDeleting}
            />
          </Button.Group>
        </Table.Cell>
      </Table.Row>
    )
  }

  handleSelect = () =>
    this.props.onSelect && this.props.onSelect(this.props.transcription)

  handleDownload = () =>
    this.props.onDownload && this.props.onDownload(this.props.transcription)

  handleDelete = () =>
    this.props.onDelete && this.props.onDelete(this.props.transcription)

  formatCreatedAt = timestamp => {
    return moment(timestamp).format('YYYY-MM-DD HH:mm')
  }
}



// WEBPACK FOOTER //
// ./src/components/TranscriptionItem.js